<app-toolbar id="kt_app_toolbar" class="app-toolbar py-lg-6"></app-toolbar>

<router-outlet></router-outlet>